import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemorizedTaskComponent } from './memorized-task.component';
import { MdbGlobalModule } from '../mdb-global.module';
import { DxButtonModule, DxAccordionModule, DxScrollViewModule, DxTagBoxModule, DxNumberBoxModule, DxDataGridModule, DxCheckBoxModule, DxPopupModule, DxSelectBoxModule, DxTextBoxModule } from 'devextreme-angular';
import { ProjectCommentsModule } from '../project-comments/project-comments.module';



@NgModule({
  declarations: [MemorizedTaskComponent],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxAccordionModule,
    DxDataGridModule,
    DxButtonModule,
    DxPopupModule,
    DxSelectBoxModule,
    DxNumberBoxModule,
    DxTextBoxModule,
    DxCheckBoxModule,
    DxTagBoxModule,
    DxScrollViewModule,
  ],
  exports: [
    MemorizedTaskComponent
  ]
})
export class MemorizedTaskModule { }
